import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import AuthLayout from '@/components/AuthLayout';
import { authApi } from '@/features/auth/auth.api';
import { extractError } from '@/lib/axios';

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export default function RegisterPage(): JSX.Element {
  const navigate = useNavigate();
  const { register, handleSubmit, formState } = useForm<FormValues>();

  const onSubmit = handleSubmit(async (values) => {
    try {
      await authApi.register(values);
      toast.success('Account created! Check your email to verify.');
      navigate('/login');
    } catch (err) {
      toast.error(extractError(err).message);
    }
  });

  return (
    <AuthLayout title="Create your account" subtitle="Start hosting meetings in minutes">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="mb-1 block text-sm font-medium">First name</label>
            <input className="input" {...register('firstName', { required: true })} />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Last name</label>
            <input className="input" {...register('lastName', { required: true })} />
          </div>
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium">Email</label>
          <input className="input" type="email" {...register('email', { required: true })} />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium">Password</label>
          <input className="input" type="password" {...register('password', { required: true })} />
          <p className="mt-1 text-xs text-slate-500">8+ chars, with upper, lower & a number.</p>
        </div>
        <button type="submit" className="btn-primary w-full" disabled={formState.isSubmitting}>
          {formState.isSubmitting ? 'Creating…' : 'Create account'}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-slate-600 dark:text-slate-400">
        Already have an account?{' '}
        <Link to="/login" className="text-brand-600 hover:underline">
          Sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
